import { getCurrentFiscalYear } from '../utils';

export const GA4_TRACKING_ID = 'G-79S2984LY4';
export const B2C_GA4_TRACKING_ID = 'G-4TX14F3R0D'; //used only for pageviews
export const CATEGORY_MARKETPLACE_WEBSITE = 'marketplace-website';
export const AY = getCurrentFiscalYear();
export const EVENTS = {
  pageView: 'pageview',
};
